import { useState } from "react";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { TasksItems } from "../../constant/data";
import { FaCheckSquare } from "react-icons/fa";
import { BiSolidSquareRounded } from "react-icons/bi";
import { TfiClose } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";

const TasksIndicator = (props:any) => {
  const [percentage, setpercentage] = useState(33);
  const [show, setshow] = useState(true);
  const navigate = useNavigate();
  return (
    <>
      {show && (
        <div className="bg-white px-4 mx-4 rounded-[8px]  pt-2 flex flex-col w-[250px]">
          <TfiClose
            className="m-1 self-end"
            onClick={() => {
              setshow(false);
            }}
            size={20}
          />

          <div className="bg-blueGray  rounded-[8px] p-10 mb-2 ">
            <CircularProgressbarWithChildren
              value={percentage} 
              text={`${percentage}%`}
            >
              <p className="mt-12 font-semibold text-white text-sm">
                Completed
              </p>
            </CircularProgressbarWithChildren>
          </div>

          {props.TasksItems.map((item: any) => (
            <div className="m-1">
              {item.checked ? (
                <FaCheckSquare size={20} className="text-primary inline" />
              ) : (
                <BiSolidSquareRounded
                  size={20}
                  className="text-[#f1f1f5] inline
"
                />
              )}
              <p className="text-sm inline ml-3 font-light">{item.name}</p>
            </div>
          ))}
          <div className="bg-white"></div>
        </div>
      )}
    </>
  );
};

export { TasksIndicator };
